import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { RapportSousSystemRaw } from '../../../../_models/RapportSousSysteme';
import { GridWrapper } from '../../../../_models/GridWrapper';
import { selectAllRapportSousSystemes } from '../../../../_store/RapportSousSystemeStore/rapport-sous-systeme.store';
import { MainStoreState } from '../../../../_store/mainStoreState';
import { Store } from '@ngrx/store';
import { GridComponent } from '@progress/kendo-angular-grid';
import { distinct } from '@progress/kendo-data-query';

@Component({
  selector: 'app-subsystem-report',
  templateUrl: './subsystem-report.component.html',
  styleUrls: ['./subsystem-report.component.scss'],
})
export class SubsystemReportComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() bodyHeight = 300;
  @Input() open = false;
  @Output() applied = new EventEmitter<any>();
  @Output() display = new EventEmitter<boolean>();

  @ViewChild('kendoGrid', { static: true }) kendoGrid!: GridComponent;

  // Grid attributes
  public gridWrapper!: GridWrapper<RapportSousSystemRaw>;

  constructor(private store: Store<MainStoreState>) {}

  ngOnInit(): void {
    this.gridWrapper = new GridWrapper<RapportSousSystemRaw>(
      'RapportSousSystemRaw',
      this.store.select(selectAllRapportSousSystemes),
      {
        logic: 'or',
        filters: [
          {
            field: 'message',
            operator: 'contains',
          },
          {
            field: 'descriptionCodeReponse',
            operator: 'contains',
          },
          {
            field: 'nomSousSysteme',
            operator: 'contains',
          },
          {
            field: 'descriptionPgm',
            operator: 'contains',
          },
        ],
      },
      this.kendoGrid
    );
    this.gridWrapper.gridState.group = [
      {
        field: 'numeroPgm',
        dir: 'asc',
      },
    ];
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.gridWrapper.groupChanged(this.gridWrapper.gridState.group);
    });
  }

  ngOnDestroy(): void {
    this.gridWrapper.destroy();
  }

  applyPgms(): void {
    this.applied.emit();
  }

  toggle(): void {
    this.open = !this.open;
  }

  getRapportNumero(group: { items: RapportSousSystemRaw[] }) {
    return group.items.length ? group.items[0].numeroPgm : '';
  }

  getRapportDescription(group: { items: RapportSousSystemRaw[] }) {
    return group.items.length ? group.items[0].descriptionPgm : '';
  }

  getRapportCommentaire(group: { items: RapportSousSystemRaw[] }) {
    return group.items.length ? group.items[0].commentairePgm : '';
  }

  public distinctPrimitive(fieldName: string): unknown[] {
    return distinct(this.gridWrapper.internalData, fieldName).map((item) => item[fieldName as unknown as keyof RapportSousSystemRaw]);
  }
}
